import { createContext, useContext } from 'react';
import type { VolunteerRollup } from '../volunteers/derive';

/**
 * Every board volunteer's schedule across all event days, by volunteer id.
 *
 * The board payload is one day, so the hover card's "and what else are they
 * doing" comes from `/shifts` + `/posts` instead. Rolled up once per data
 * change rather than per hover, and reached through a context for the same
 * reason as the axis: only the innermost block wants it, and it would
 * otherwise be a parameter on every component between here and there.
 *
 * Empty until those two queries resolve — the card falls back to the day's own
 * numbers, which the board already has.
 */
export const ScheduleContext = createContext<Map<string, VolunteerRollup>>(new Map());

export function useSchedule() {
  return useContext(ScheduleContext);
}
